import { isHandleMappingForOrganization, isHandleMappingForUser } from "@buildwithflux/models";
function deserialize(snapshot) {
    const data = {
        ...snapshot.data(),
        userHandle: snapshot.id,
    };
    if (isHandleMappingForUser(data)) {
        return {
            ...data,
            organizationUid: undefined,
        };
    }
    if (isHandleMappingForOrganization(data)) {
        return {
            ...data,
            user_uid: undefined,
        };
    }
    throw new Error(`Invalid HandleMapping: ${JSON.stringify(data)}`);
}
function serialize(modelObject) {
    return {
        ...modelObject,
        organizationUid: modelObject.organizationUid ?? null,
        user_uid: modelObject.user_uid ?? null,
    };
}
/**
 * Converts organization_uid between undefined (model repr) and null (firestore repr)
 */
export class HandleMappingAdminConverter {
    toFirestore(modelObject) {
        return serialize(modelObject);
    }
    fromFirestore(snapshot) {
        return deserialize(snapshot);
    }
}
/**
 * Converts organization_uid between undefined (model repr) and null (firestore repr)
 */
export class HandleMappingClientConverter {
    toFirestore(modelObject) {
        return serialize(modelObject);
    }
    fromFirestore(snapshot) {
        return deserialize(snapshot);
    }
}
//# sourceMappingURL=HandleMappingConverter.js.map